import Vue from 'vue';
import App from './App.vue';
import './assets/styles/responsive.css';
import VueI18n from 'vue-i18n';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/styles/global.css';
import VueLazyload from 'vue-lazyload';
import Storage from 'vue-ls';
import { ACCESS_TOKEN, USER_NAME, USER_INFO,Cache } from "@/store/mutation-types"
import MessagePlugin from '@/utils/message';

import api from '@/api'
import result from './api/modules/result';
import VueMeta from 'vue-meta';

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true // 路由切换时自动更新 head 标签[6,8](@ref)
});
// 配置vue-ls插件
Vue.use(Storage, {
  namespace: 'vuejs__',
  name: 'ls',
  storage: 'local'
});

Vue.use(VueI18n);
Vue.use(ElementUI);
Vue.use(VueLazyload);
Vue.use(MessagePlugin);
 
 
const messages = {
  en: {
    welcome: 'Welcome to the Conference',
    home: 'Home',
    
    aboutConference: 'About',
    background: 'Background',
    charter: 'Charter',
    committee: 'Committee',
    experts: 'Experts',
    contact: 'Contact Us',
    newsCenter: 'News Center',
    news:'News Center',
    announcements: 'Announcements',
    info: 'Conference Info',
    future: 'Future of Vocational Education',
    events: 'Events',
    pastEvents: 'Past Events',
    currentEvents: 'conference events',
    eduPlusEvents: 'education Plus Events',
    otherEvents: 'Other Events',
    members: 'Members',
    aboutMembers: 'About Members',
    joinMembers: 'Join Members',
    partners: 'Partners',
    partnerIntro: 'Partner Introduction',
    partnerThanks: 'Partner Thanks',
    partnerNews: 'Partner News',
    partnerApply: 'Partner Application',
    results: 'Results',
    userCenter: 'User Center',
    profile: 'My Account',
    registrations: 'My Registrations',
    security: 'Security Settings',
    logout: 'Logout',
    login: 'Login',
    newsDynamic: 'News Dynamic',
    specialColumn: 'Special Column',
    announcementsTitle: 'Announcements',
    moreInfo: 'Learn More',
    conferencePreview: 'World Map of Vocational Education Institutions',
    skillCompetition: '“Von Neumann Cup” Boao International Vocational Skills Challenge',
    vocationalFuture: 'Vocational Future',
    expertsTitle: 'Experts',
    resultsTitle: 'Results',
    partnersTitle: 'Partners',
    mainMembers: 'Main Members',
     careerCompetition: 'Competition',
     vocEdMap: 'VocEd Map',
     influenceIndex:'Asia-Pacific Vocational College Influence Index' ,
     exemplaryInstitutions:'Exemplary Institutions',
     outstandingCases:'Outstanding Cases',
     notableContributions:'Notable Contributions',
     distinguishedEducators:'Distinguished Educators',
     introCommitee: 'Committee introduction',
     exemplaryProject:'Model Project',
     forum:'forum',
     result :'achievement',
     form: 'registration form',
     column:'column',
     newsDetail:'newsDetail',
     subList:'CompetitionSubList',
     subDetail:'CompetitionSubDetail'

  },
  zh: {
    welcome: '欢迎来到会议',
    home: '首页',
    aboutConference: '关于大会',
    background: '大会背景',
    charter: '大会章程',
    committee: '组委会',
    experts: '智库专家',
    contact: '联系我们',
    newsCenter: '新闻中心',
    news: '新闻中心',
    announcements: '通知公告',
    info: '大会资讯',
    future: '职教未来',
    events: '会议活动',
    pastEvents: '历届活动',
    currentEvents: '大会活动',
    eduPlusEvents: 'education Plus大会',
    otherEvents: '其他活动',
    members: '会员专区',
    aboutMembers: '关于会员',
    joinMembers: '申请入会',
    partners: '合作伙伴',
    partnerIntro: '合作伙伴介绍',
    partnerThanks: '合作伙伴鸣谢',
    partnerNews: '合作伙伴动态',
    partnerApply: '合作伙伴申请',
    results: '成果展示',
    userCenter: '个人中心',
    profile: '我的账号',
    registrations: '我的报名',
    security: '安全设置',
    logout: '退出登录',
    login: '登录',
    newsDynamic: '新闻动态',
    specialColumn: '专题栏目',
    announcementsTitle: '通知公告',
    moreInfo: '了解更多',
    conferencePreview: '世界职教院校图谱',
    skillCompetition: '“冯诺依曼杯”博鳌国际职业技能挑战赛',
    vocationalFuture: '职教未来',
    expertsTitle: '智库专家',
    resultsTitle: '成果展示',
    partnersTitle: '合作伙伴',
    mainMembers: '主要会员单位',
    careerCompetition: '职业大赛',
    vocEdMap: '职教图谱',
    influenceIndex:'亚太影响力指数星级院校' ,
    exemplaryInstitutions:'典型院校',
    outstandingCases:'优秀案例',
    notableContributions:'突出贡献',
    distinguishedEducators:'杰出教育工作者',
    introCommitee: '组委会简介',
    exemplaryProject:'示范项目',
    forum:'平行论坛',
    competition:'职业大赛',
    result:'成果展示' ,
    user:'用户',
    myEvents:'我的报名',
    registration:'会议报名',
    form:'填报信息',
    register:'注册',
    project:'示范项目',
    details:'详情',
    column:'专题栏目',
    newsDetail:'详情',
    intro: '介绍',
    case:'案例征集',
    meetingRace:'会议大赛',
    subList:'赛项列表',
    subDetail:'赛项详情',

  }
};

const i18n = new VueI18n({
  locale:  localStorage.getItem('lang') || 'zh',
  messages,
});
const app = new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
  created() {
    // 初始化语言
    this.$api=api;
  },
  mounted() {
    store.commit('setToken', Cache.get(ACCESS_TOKEN))
    store.commit('setUser',  Cache.get(USER_INFO))
    store.commit('setUsername', Cache.get(USER_NAME))
  }
})


// 响应式字体更新
const updateFontSize = () => {
  // const baseSize = window.innerWidth > 768 ? 16 : 14
  // document.documentElement.style.fontSize = `${baseSize}px`
}

window.addEventListener('resize', updateFontSize)
updateFontSize()
app.$mount('#app');